
import Vue from 'vue'
import AccountTransformer from '@/transformers/account'
import store from '@/store'

/**
 * @author José Luis R. <jose.ruiz@jbge.com.mx>
 * Fetches all users belonging to a group
 * @return {Array} An Array with all existing business units
 * @param group Group's name. Ex: CoDi, Supervisors, ACo
 */

function paramsTransformer({ notFilter }) {
  return {
    not_filter: notFilter ? 1 : undefined
  }
}

export default (group = '', options = {}) => {
  const params = paramsTransformer(options)
  const { catalog } = options
  const storedData = store.state.catalogs && store.state.catalogs[catalog]

  if (storedData && storedData.length) {
    return Promise.resolve(storedData)
  }

  return Vue.$http.get(`users/by_group/${group ? group + '/' : ''}`, { params })
    .then(response => {
      const items = AccountTransformer.fetchCollection(response.data).sort((a, b) => a.fullName.toLowerCase() > b.fullName.toLowerCase() ? 0 : -1)
      if (catalog) {
        store.dispatch('catalogs/store', {
          catalog,
          data: items,
          urlGroup: 'users'
        })
      }

      return items
    })
    .catch(err => {
      throw err
    })
}
